import {
  ClassSansProvider,
  FactorySansProvider,
  InjectionToken,
  Type,
} from '@angular/core';
import { AuthService } from './auth-service.interface';

export const AuthServiceInjectionToken = new InjectionToken<AuthService>(
  'AuthService',
);

export interface AuthServiceUseClass extends ClassSansProvider {
  useClass: Type<AuthService>;
}

export interface AuthServiceUseFactory extends FactorySansProvider {
  useFactory: (...args: unknown[]) => AuthService;
}

export type AuthServiceProvider = AuthServiceUseFactory | AuthServiceUseClass;

export function provideAuthService(config: AuthServiceProvider) {
  return {
    provide: AuthServiceInjectionToken,
    ...config,
  };
}
